import API from './API';

const path = `dashboard`;

const DashboardService = {
    // INICIO
    init: async filters => await API.filters(path, filters),
}

export default DashboardService;